import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';

import FacebookIcon from './assets/facebook.inline.svg';
import InstagramIcon from './assets/instagram.inline.svg';
import LinkdeinIcon from './assets/linkdein.inline.svg';
import TwitterIcon from './assets/twitter.inline.svg';

interface Props extends StyleProps {
  href?: string;
  icon: 'facebook' | 'instagram' | 'twitter' | 'linkedin';
  target?: string;
}

export const RoundedIconBtn: FC<Props> = ({ style, className, href = '#', icon, target }) => {
  return (
    <a
      target={target}
      style={style}
      href={href}
      aria-label={icon}
      className={mc(
        'w-10 h-10 rounded-full border',
        'hover:border-accent-orange border-ocean-blue fill-ocean-blue hover:fill-accent-orange',
        'flex flex-col items-center justify-center',
        className,
      )}
    >
      {icon === 'facebook' && <FacebookIcon />}
      {icon === 'instagram' && <InstagramIcon />}
      {icon === 'twitter' && <TwitterIcon />}
      {icon === 'linkedin' && <LinkdeinIcon />}
    </a>
  );
};

export type RoundedIconBtnProps = Props;
export default RoundedIconBtn;
